import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-request-status-popup',
  templateUrl: './request-status-popup.component.html',
  styleUrls: ['./request-status-popup.component.css']
})
export class RequestStatusPopupComponent implements OnInit {

  @Input() modalData: any;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    
  }

}
